import React, { FC } from 'react';

interface AssistantRegenerateIconProps {
  size: number;
  style?: Record<string, string | number>;
}

// source: https://roblox.atlassian.net/browse/CREATORUX-1701
const AssistantRegenerateIcon: FC<React.PropsWithChildren<AssistantRegenerateIconProps>> = ({
  size,
  style,
}) => (
  <svg
    width={size}
    height={size}
    style={style}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.0101 9.9996C26.0191 9.9999 26.028 10 26.037 10C26.0462 10 26.0553 9.9999 26.0644 9.9996H26.492C27.3205 9.9996 27.992 9.3281 27.992 8.4996V1.92858C27.992 1.37629 27.5443 0.92858 26.992 0.92858C26.4398 0.92858 25.992 1.3763 25.992 1.92858V6.78205C23.5419 2.71793 19.0852 0 13.9937 0C8.1368 0 3.11991 3.59654 1.03107 8.7016C0.770951 9.3373 1.2635 10 1.95039 10C2.38558 10 2.76957 9.7237 2.93932 9.323C4.76246 5.01922 9.0255 2 13.9937 2C18.4353 2 22.3132 4.41303 24.3881 7.99965H19.921C19.3687 7.99965 18.921 8.4474 18.921 8.9996C18.921 9.5519 19.3687 9.9996 19.921 9.9996H26.0101Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.98143 18.0004C1.97248 18.0001 1.96351 18 1.95452 18C1.94535 18 1.93622 18.0001 1.92712 18.0004H1.49951C0.671092 18.0004 -0.000488281 18.6719 -0.000488281 19.5004V26.0714C-0.000488281 26.6237 0.447232 27.0714 0.999512 27.0714C1.5518 27.0714 1.99951 26.6237 1.99951 26.0714V21.2179C4.44966 25.2821 8.9063 28 13.9978 28C19.8547 28 24.8716 24.4035 26.9605 19.2984C27.2206 18.6627 26.728 18 26.0412 18C25.606 18 25.222 18.2763 25.0522 18.677C23.2291 22.9808 18.9661 26 13.9978 26C9.5563 26 5.67834 23.587 3.60343 20.0004H8.0706C8.6229 20.0004 9.0706 19.5526 9.0706 19.0004C9.0706 18.4481 8.6229 18.0004 8.0706 18.0004H1.98143Z'
      fill='currentColor'
    />
  </svg>
);

export default AssistantRegenerateIcon;
